import { Info } from 'lucide-react';
import { Button } from '@/components/ui';

export interface ErrorStateProps {
  message?: string;
  onRetry: () => void;
}

export function ErrorState({
  message = 'Unable to load items',
  onRetry,
}: ErrorStateProps) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center px-5 pb-24">
      <Info
        size={32}
        className="text-danger mb-4"
      />
      <p className="text-xl font-medium text-foreground mb-4">{message}</p>
      <Button
        variant="outline"
        onClick={onRetry}
      >
        Reload
      </Button>
    </div>
  );
}
